import * as React from 'react';

import _t from 'i18n!nls/enterprise-collections';

export default function CollectionTitle({ title = _t('Company Collection') }: { title: string }) {
  return <span>{title}</span>;
}
